import { MenuItem } from "../../../models/menu-item";

export const dashboardMenu: MenuItem = {
  iconName: "dashboard",
  displayName: "Dashboard",
  children: [],
  disable: '',
  idItem: 'dashboard',
  itemType: 'menuVoice',
  menuScope: [],
  name: 'DASHBOARD',
  route: '/dashboard'
};

export const customerJourneyMenu: MenuItem = {
  iconName: "map",
  displayName: "Journey",
  children: [],
  disable: '',
  idItem: 'JOURNEY',
  itemType: 'menuVoice',
  menuScope: [],
  name: 'home',
  route: '/home'
};

export const verbatimMenu: MenuItem = {
  children: [],
  disable: 'false',
  displayName: "Verbatim",
  iconName: 'hive', // 'bubble_chart',
  idItem: 'verbatim',
  itemType: 'verbatim',
  menuScope: [],
  route: "/verbatim"
};

export const downloadMenu: MenuItem = {
  children: [],
  disable: 'false',
  displayName: "Download",
  iconName: 'download',
  idItem: 'download',
  itemType: 'download',
  menuScope: [],
  route: "/download"
}

export const reportDownloadMenu: MenuItem = {
  children: [],
  disable: 'false',
  displayName: "Reporting",
  iconName: 'summarize',
  idItem: 'reporting',
  itemType: 'reporting',
  menuScope: [],
  route: "/reporting"
}

export const videoTutorialMenu: MenuItem = {
  children: [],
  disable: 'false',
  displayName: "Video Tutorial",
  iconName: 'movie',
  idItem: 'videoTutorial',
  itemType: 'menuVoice',
  menuScope: [],
  route: "/videoTutorial"
}

export const customerDataUploaderMenu: MenuItem = {
  children: [],
  disable: 'false',
  displayName: "Upload Customer Data",
  iconName: 'file_upload',
  idItem: 'customerDataUploader',
  itemType: 'menuVoice',
  menuScope: [],
  route: "/customerDataUploader"
}


export const defaultMenu: (scope?: string, roles?: string[]) => MenuItem = (scope?: string, roles?: string[]) => {
  const children = [
    dashboardMenu,
    verbatimMenu,
    downloadMenu
  ];
  if (scope == 'JOURNEY' || (roles && roles.find(x => x == 'JOURNEY_VISIBILITY'))) {
    children.unshift(customerJourneyMenu)
  }

  if (roles && roles.find(x => x == 'VIEW_POWER_BI_REPORT')) {
    children.push(reportDownloadMenu)
  }

  children.push(videoTutorialMenu);

  if (roles && roles.find(x => x == 'CUSTOMERDATA_UPLOADER_VISIBILITY')) {
    children.push(customerDataUploaderMenu)
  }


  return {
    children: [],
    disable: '',
    displayName: 'Home',
    iconName: '',
    idItem: 'Home',
    itemType: '',
    menuScope: [{
      disable: '',
      displayName: '',
      iconName: '',
      idItem: '',
      itemType: '',
      menuScope: [],
      children: children
    }],
    name: '',
    path: '',
    route: '',
  }
}
